export default __webpack_public_path__ + "static/Studies&Me_Collaboration_with_Coegin_Pharma AB_26.01.2021-57865c409af4a23d58e6d08487493d84.pdf";